import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {searchSalons} from './actions';
import {bindActionCreators} from "redux";
import {Link} from "react-router-dom";
import ListView from "../common/ListView";
import AddressDisplay from "../common/AddressDisplay";

class SalonListPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    searchSalons: PropTypes.func.isRequired,
    search: PropTypes.object.isRequired,
  };

  render() {
    const {
      history, searchSalons,
      search: {searching, pagination, filters, sorter, searchFilter, results},
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        className: 'one-line-column',
      },
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
        sorter: true,
        render: (_, {addressObj}) => <AddressDisplay address={addressObj}/>,
      },
      {
        title: 'Phone',
        dataIndex: 'phoneNumber',
        key: 'phoneNumber',
        sorter: true,
        className: 'one-line-column',
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        sorter: true,
      },
      {
        title: 'Action',
        key: 'action',
        className: 'one-line-column',
        render: (_, {salonId}) => {
          const encodedId = encodeURIComponent(salonId);
          return (
            <React.Fragment>
              <Link to={`/salon/update/${encodedId}`}>Edit</Link>
            </React.Fragment>
          );
        },
      }
    ];
    return (
      <ListView
        title="Salons"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchSalons}
        dataSource={results}
        pagination={pagination}
        searchFilter={searchFilter}
        filters={filters}
        sorter={sorter}
        onAdd={() => history.push('/salon/add')}
        rowKey="salonId"
      />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.salon.salonListLoading,
  search: state.salon.search,
});

const mapDispatchToProps = dispatch => ({
  searchSalons: bindActionCreators(searchSalons, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SalonListPage);



// WEBPACK FOOTER //
// ./src/Salon/SalonListPage.js